import classNames from 'classnames'
import React from 'react'

export interface IconProps {
    className?: string
}

export const AccountIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 32 32" fill="#000">
        <path
            stroke="currentColor"
            strokeLinejoin="round"
            strokeWidth="1.5"
            fill="none"
            d="M22.4812 8.18878c0 3.27992-2.6588 5.93882-5.9387 5.93882s-5.9388-2.6589-5.9388-5.93882c0-3.2799 2.6589-5.93878 5.9388-5.93878 3.2799 0 5.9387 2.65888 5.9387 5.93878ZM7.11389 27.6735c0-5.3679 4.35151-9.7194 9.71941-9.7194s9.7194 4.3515 9.7194 9.7194V28c0 .6903-.5597 1.25-1.25 1.25H8.36389c-.69035 0-1.25-.5597-1.25-1.25v-.3265Z"
        />
    </svg>
)

export const AlertIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} fill="none" viewBox="0 0 24 24">
        <path
            d="M13.5 14H11.5V9H13.5M13.5 18H11.5V16H13.5M1.5 21H23.5L12.5 2L1.5 21Z"
            stroke="none"
            fill="currentColor"
        />
    </svg>
)

export const ArrowLeftIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} fill="none" viewBox="0 0 24 24">
        <path d="M19 12H5M12 19l-7-7 7-7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const BurgerIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} fill="none" viewBox="0 0 24 24">
        <path fill="currentColor" stroke="none" d="M2 5v2h20V5H2Zm0 6v2h20v-2H2Zm0 6v2h20v-2H2Z" />
    </svg>
)

export const CalendarIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            stroke="none"
            d="M9.70213 8.41722c.63577 0 1.14897.53245 1.14897 1.19205 0 .65963-.5132 1.19203-1.14897 1.19203-.63575 0-1.14894-.5324-1.14894-1.19203 0-.6596.51319-1.19205 1.14894-1.19205Zm4.59577 0c.6357 0 1.1489.53245 1.1489 1.19205 0 .65963-.5132 1.19203-1.1489 1.19203-.6358 0-1.149-.5324-1.149-1.19203 0-.6596.5132-1.19205 1.149-1.19205Zm4.5957 0c.6358 0 1.149.53245 1.149 1.19205 0 .65963-.5132 1.19203-1.149 1.19203-.6357 0-1.1489-.5324-1.1489-1.19203 0-.6596.5132-1.19205 1.1489-1.19205ZM5.10638 12.6556c.63575 0 1.14894.5325 1.14894 1.1921s-.51319 1.192-1.14894 1.192c-.63574 0-1.14893-.5324-1.14893-1.192s.51319-1.1921 1.14893-1.1921Zm4.59575 0c.63577 0 1.14897.5325 1.14897 1.1921s-.5132 1.192-1.14897 1.192c-.63575 0-1.14894-.5324-1.14894-1.192s.51319-1.1921 1.14894-1.1921Zm4.59577 0c.6357 0 1.1489.5325 1.1489 1.1921s-.5132 1.192-1.1489 1.192c-.6358 0-1.149-.5324-1.149-1.192s.5132-1.1921 1.149-1.1921ZM4.7234 4.04636H1.2766V19.6755h21.4468V4.04636h-3.4468v1.72185H18V4.04636H6v1.72185H4.7234V4.04636ZM6 1v1.72185h12V1h1.2766v1.72185H24V21H0V2.72185h4.7234V1H6Z"
        />
    </svg>
)

export const CheckCircleIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <mask id="a" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <path fill="currentColor" d="M0 0h24v24H0z" />
        </mask>
        <g mask="url(#a)" stroke="none">
            <path
                d="m10.6 16.6 7.05-7.05-1.4-1.4-5.65 5.65-2.85-2.85-1.4 1.4 4.25 4.25ZM12 22a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0 1 12 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 0 1 3.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0 1 22 12a9.733 9.733 0 0 1-.788 3.9 10.092 10.092 0 0 1-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
                fill="currentColor"
            />
        </g>
    </svg>
)

export const CheckCircleLargeIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 32 32" fill="none">
        <path
            fill="currentColor"
            stroke="none"
            d="m22.5323 10.8492 1.0862 1.0893-9.0093 8.9969-6.23073-6.2246 1.08615-1.0893L14.6092 18.76l7.9231-7.9108ZM16 3.53846C9.11692 3.53846 3.53846 9.11692 3.53846 16c0 6.8831 5.57846 12.4615 12.46154 12.4615 6.8831 0 12.4615-5.5784 12.4615-12.4615 0-6.88308-5.5784-12.46154-12.4615-12.46154ZM16 2c7.7323 0 14 6.26769 14 14 0 7.7323-6.2677 14-14 14-7.73231 0-14-6.2677-14-14C2 8.26769 8.26769 2 16 2Z"
        />
    </svg>
)

export const CheckIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <path
            fill="currentColor"
            stroke="none"
            d="M19.4645 6.12109 11.707 13.8785 7.41406 9.58556 6 10.9996l5.707 5.7071 9.1715-9.17154-1.414-1.41407Z"
        />
    </svg>
)

export const CheckSmallIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#b)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m15.071 4.897-7.955 7.955L.929 6.664l1.06-1.06 5.127 5.126 6.894-6.894 1.061 1.06Z"
                stroke="none"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="b">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const ChevronDownIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.4185 9.09597L12.2091 15.502L5.99979 9.09597L7.06287 8.0791L12.2091 13.3842L17.3554 8.0791L18.4185 9.09597Z"
            stroke="none"
            fill="currentColor"
        />
    </svg>
)

export const ChevronDownLargeIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#c)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.316 7.318 12 18.634.682 7.315l1.06-1.06L12 16.512 22.255 6.257l1.06 1.061Z"
                stroke="none"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="c">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const ChevronLeftIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m13.983 18-6.406-6.21 6.406-6.209L15 6.644l-5.305 5.147L15 16.937 13.983 18Z"
            stroke="none"
            fill="currentColor"
        />
    </svg>
)

export const ChevronLeftLargeIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_6452_39545)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.9974.681938 5.68189 11.9974 17 23.3155l1.0606-1.0607L7.80322 11.9974 18.058 1.7426 16.9974.681938Z"
                stroke="none"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_6452_39545">
                <path fill="#fff" d="M0 24h24V0H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const ChevronLeftSmallIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 16 16" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.693 14.21 4.287 8l6.406-6.209 1.017 1.063-5.305 5.147 5.305 5.146-1.017 1.063Z"
            stroke="none"
            fill="currentColor"
        />
    </svg>
)

export const ChevronRightIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.594 6 15 12.21l-6.406 6.209-1.017-1.063 5.305-5.147-5.305-5.146L8.594 6Z"
            stroke="none"
            fill="currentColor"
        />
    </svg>
)

export const ChevronRightLargeIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 20 20" fill="none">
        <g clipPath="url(#clip0_6596_6266)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.83358 0.568281L15.2631 9.99784L5.83142 19.4296L4.94753 18.5457L13.4954 9.99784L4.94969 1.45216L5.83358 0.568281Z"
                stroke="none"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_6596_6266">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const ChevronUpIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m6 14.485 6.21-6.406 6.209 6.406-1.063 1.017-5.147-5.305-5.146 5.305L6 14.485Z"
            stroke="none"
            fill="currentColor"
        />
    </svg>
)

export const ChevronUpLargeIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#d)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.682 14.255 11.997 2.939l11.319 11.318-1.061 1.06L11.997 5.062 1.743 15.315l-1.061-1.06Z"
                stroke="none"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="d">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const CloseIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="#000">
        <path
            d="m19.584 4 .81.81-7.387 7.387 7.386 7.386-.81.81-7.386-7.386-7.387 7.387-.81-.81 7.387-7.387L4 4.81 4.81 4l7.387 7.386L19.584 4Z"
            stroke="none"
            fill="currentColor"
        />
    </svg>
)

export const CommunityIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 20 20" fill="#000">
        <path d="M9.98 19.27c-5.14 0-9.31-4.17-9.3-9.3C.69 4.84 4.85.68 9.98.68c5.13 0 9.3 4.17 9.29 9.31 0 5.12-4.17 9.28-9.29 9.28zm.04-17.39c-4.51-.01-8.14 3.6-8.14 8.08-.01 4.48 3.61 8.12 8.06 8.12 4.51 0 8.14-3.6 8.14-8.1 0-4.46-3.61-8.1-8.06-8.1z" />
        <path d="M9.01 8.02c0-.39.18-.68.53-.85.35-.16.68-.1.98.14.21.17.33.41.33.68v6.71c0 .51-.43.91-.93.91s-.91-.41-.91-.92C9 13.58 9 12.46 9 11.34c0-1.11 0-2.21.01-3.32zM7.8 13.13c0 .56-.4.97-.92.97-.53 0-.92-.42-.92-.98V9.3c0-.56.39-.98.91-.98.54 0 .93.41.93.99v3.82zm6.13-.01c0 .57-.39.98-.92.98s-.92-.41-.92-.98V9.29c0-.56.4-.97.93-.97.52 0 .91.42.91.97v3.83zm-3.05-7.56c0 .52-.43.95-.95.94A.959.959 0 0 1 9 5.55c.01-.51.43-.93.95-.93.51 0 .93.43.93.94zM5.96 6.79c0-.52.43-.94.95-.94.51.01.93.44.92.96 0 .51-.43.93-.94.92-.51 0-.94-.43-.93-.94zm8.01.01a.95.95 0 0 1-.94.93c-.52 0-.95-.43-.94-.95 0-.51.43-.93.94-.93.52.01.94.43.94.95z" />
    </svg>
)

export const ContactIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            stroke="none"
            d="M6.84089 16.8756C7.59644 16.3316 8.39822 15.9016 9.24622 15.5858C10.0936 15.2693 11.0116 15.1111 12 15.1111C12.9879 15.1111 13.9058 15.2693 14.7538 15.5858C15.6012 15.9016 16.403 16.3313 17.1591 16.8747C17.7458 16.2679 18.2178 15.5508 18.5751 14.7236C18.9324 13.8951 19.1111 12.9873 19.1111 12C19.1111 10.0296 18.4187 8.3517 17.0338 6.96622C15.6489 5.58074 13.971 4.8883 12 4.88889C10.0296 4.88889 8.3517 5.58163 6.96622 6.96711C5.58074 8.35259 4.8883 10.0302 4.88889 12C4.88889 12.9879 5.06756 13.8954 5.42489 14.7227C5.78222 15.5505 6.25422 16.2681 6.84089 16.8756ZM12.0009 12.4444C11.2519 12.4444 10.6199 12.1873 10.1049 11.6729C9.59052 11.1591 9.33333 10.5277 9.33333 9.77867C9.33333 9.02963 9.59052 8.39763 10.1049 7.88267C10.6187 7.3683 11.2501 7.11111 11.9991 7.11111C12.7481 7.11111 13.3801 7.3683 13.8951 7.88267C14.4095 8.39644 14.6667 9.02785 14.6667 9.77689C14.6667 10.5259 14.4095 11.1579 13.8951 11.6729C13.3813 12.1873 12.7499 12.4444 12.0009 12.4444ZM12 20C10.8841 20 9.8397 19.7923 8.86667 19.3769C7.89363 18.9621 7.04681 18.3944 6.32622 17.6738C5.60622 16.9532 5.03852 16.1064 4.62311 15.1333C4.2077 14.1603 4 13.1159 4 12C4 10.8841 4.2077 9.8397 4.62311 8.86667C5.03793 7.89363 5.60563 7.04681 6.32622 6.32622C7.04681 5.60622 7.89363 5.03852 8.86667 4.62311C9.8397 4.2077 10.8841 4 12 4C13.1159 4 14.1603 4.2077 15.1333 4.62311C16.1064 5.03793 16.9532 5.60563 17.6738 6.32622C18.3938 7.04681 18.9615 7.89363 19.3769 8.86667C19.7923 9.8397 20 10.8841 20 12C20 13.1159 19.7923 14.1603 19.3769 15.1333C18.9621 16.1064 18.3944 16.9532 17.6738 17.6738C16.9532 18.3938 16.1064 18.9615 15.1333 19.3769C14.1603 19.7923 13.1159 20 12 20ZM12 19.1111C12.8196 19.1111 13.6258 18.9677 14.4187 18.6809C15.2121 18.3947 15.8978 18.0024 16.4756 17.504C15.8978 17.0406 15.2293 16.6741 14.4702 16.4044C13.7117 16.1348 12.8883 16 12 16C11.1123 16 10.2862 16.1319 9.52178 16.3956C8.75733 16.6593 8.09156 17.0287 7.52444 17.504C8.10222 18.0018 8.78785 18.3941 9.58133 18.6809C10.3742 18.9677 11.1804 19.1111 12 19.1111ZM12 11.5556C12.499 11.5556 12.92 11.384 13.2631 11.0409C13.6062 10.6978 13.7778 10.2767 13.7778 9.77778C13.7778 9.27881 13.6062 8.85778 13.2631 8.51467C12.92 8.17156 12.499 8 12 8C11.501 8 11.08 8.17156 10.7369 8.51467C10.3938 8.85778 10.2222 9.27881 10.2222 9.77778C10.2222 10.2767 10.3938 10.6978 10.7369 11.0409C11.08 11.384 11.501 11.5556 12 11.5556Z"
        />
    </svg>
)

export const CopyIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="#000">
        <path
            fill="currentColor"
            stroke="none"
            d="M10.1667 19.5h9v-12h-9v12ZM8.66675 7.992c0-1.1.902-1.992 2.00895-1.992h7.982c1.11 0 2.009.893 2.009 1.992v11.016c0 1.1-.902 1.992-2.009 1.992h-7.981c-.2627.0012-.5232-.0494-.76639-.1489-.24323-.0994-.46448-.2458-.65112-.4308-.18665-.185-.33504-.4049-.43669-.6472-.10165-.2424-.15457-.5023-.15575-.7651V7.992Z"
        />
        <path
            fill="currentColor"
            stroke="none"
            d="M5.66675 16V4.992c0-1.1.902-1.992 2.009-1.992h7.99095v13H5.66675Zm1.5 0h8.49995V4.5H7.16675V16Z"
        />
    </svg>
)

export const DamageAudioIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 36 48" fill="#000">
        <g stroke="none" fill="currentColor" clipPath="url(#clip0_6387_39422)">
            <path
                fillRule="evenodd"
                d="M24 0H4C1.79086 0 0 1.79086 0 4v40c0 2.2091 1.79086 4 4 4h20c2.2091 0 4-1.7909 4-4v-7h-2v7c0 1.1046-.8954 2-2 2H4c-1.10457 0-2-.8954-2-2V4c0-1.10457.89543-2 2-2h20c1.1046 0 2 .89543 2 2v6h2V4c0-2.20914-1.7909-4-4-4Z"
                clipRule="evenodd"
            />
            <circle cx="7" cy="7" r="2" />
            <path d="M26.6942 14.0188h-.1036c-2.7414 0-3.272.6872-3.2846 2.0441v7.2919c0 2.0971 1.473 3.8026 3.2846 3.8026s3.2847-1.7055 3.2847-3.8026v-7.2414c0-1.372-.4953-2.0795-3.1811-2.0971v.0025Zm5.2024 2.0971v7.2414c0 3.2114-2.3801 5.8239-5.306 5.8239-2.9258 0-5.306-2.6125-5.306-5.8239v-7.2414c0-3.8329 3.3377-4.0982 4.9725-4.1159h.6216c1.6145.0126 5.0204.2451 5.0204 4.1159h-.0025Zm-11.8753 7.5042c0 3.6484 2.9461 6.6173 6.5693 6.6173s6.5693-2.9689 6.5693-6.6173h2.0213c0 4.7627-3.8531 8.6386-8.5906 8.6386-4.7375 0-8.5906-3.8759-8.5906-8.6386h2.0213Zm9.854 9.3486V34.99H23.306v-2.0213h6.5693Z" />
            <rect width="8" height="2" x="10" y="41" rx="1" />
        </g>
        <defs>
            <clipPath id="clip0_6387_39422">
                <path fill="#fff" d="M0 0h36v48H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const DamageBackIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 36 48" fill="#000">
        <rect width="26" height="46" x="5" y="1" fill="none" stroke="currentColor" strokeWidth="2" rx="3" />
        <circle cx="11" cy="7" r="2" stroke="none" fill="currentColor" />
        <path stroke="currentColor" fill="none" strokeWidth="2" d="m5.5 32 4.5 8 6-7 15 9.5" />
    </svg>
)

export const DamageCameraIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 36 48" fill="#000">
        <path
            fill="currentColor"
            stroke="none"
            fillRule="evenodd"
            d="M24 0H4C1.79086 0 0 1.79086 0 4v40c0 2.2091 1.79086 4 4 4h20c2.2091 0 4-1.7909 4-4v-9h-2v9c0 1.1046-.8954 2-2 2H4c-1.10457 0-2-.8954-2-2V4c0-1.10457.89543-2 2-2h20c1.1046 0 2 .89543 2 2v10h2V4c0-2.20914-1.7909-4-4-4Z"
            clipRule="evenodd"
        />
        <rect
            width="15"
            height="21"
            x="33"
            y="17"
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            rx="3"
            transform="rotate(90 33 17)"
        />
        <rect width="7" height="7" x="19" y="21" stroke="currentColor" fill="none" strokeWidth="2" rx="3.5" />
        <circle cx="7" cy="7" r="2" fill="currentColor" stroke="none" />
        <circle cx="29.5" cy="20.5" r="1.5" fill="currentColor" stroke="none" />
    </svg>
)

export const DamageFrontIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 36 48" fill="#000">
        <rect width="26" height="46" x="5" y="1" stroke="currentColor" fill="none" strokeWidth="2" rx="3" />
        <path stroke="currentColor" fill="none" strokeWidth="2" d="m5.5 7.5 4.5 8 6-7L31 18" />
        <rect width="8" height="2" x="14" y="40" fill="currentColor" stroke="none" rx="1" />
    </svg>
)

export const DamageNetworkIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 36 48" fill="#000">
        <g fill="currentColor" stroke="none" clipPath="url(#clip0_6387_39471)">
            <path
                fillRule="evenodd"
                d="M24 0H4C1.79086 0 0 1.79086 0 4v40c0 2.2091 1.79086 4 4 4h20c2.2091 0 4-1.7909 4-4v-6h-2v6c0 1.1046-.8954 2-2 2H4c-1.10457 0-2-.8954-2-2V4c0-1.10457.89543-2 2-2h20c1.1046 0 2 .89543 2 2v7h2V4c0-2.20914-1.7909-4-4-4Z"
                clipRule="evenodd"
            />
            <circle cx="7" cy="7" r="2" />
            <rect width="8" height="2" x="10" y="41" rx="1" />
            <path d="M25.0005 30.0929c.6944 0 1.3324.2422 1.8342.6454L25.0005 33l-1.8342-2.2617c.5188-.4188 1.1665-.6467 1.8342-.6454ZM16.0608 14l17.1918 17.1307-1.3752 1.3702-5.0378-5.0196c-.5932-.1961-1.2141-.2959-1.8391-.2955-1.3888 0-2.6648.4835-3.6665 1.2907l-1.2215-1.5078c1.2779-1.0316 2.8523-1.631 4.4951-1.7113l-2.5248-2.5157c-1.3886.3922-2.6829 1.0611-3.8046 1.9662l-1.2234-1.5078c1.0482-.8458 2.2256-1.5188 3.4875-1.9933l-2.2213-2.2143c-1.1057.5246-2.1454 1.1775-3.0975 1.9449L14 19.4305c.8899-.7171 1.8508-1.3479 2.871-1.8819l-2.1863-2.1774L16.0608 14Zm11.3711 8.6167-2.2213-2.2123-.2101-.0019c3.01 0 5.774 1.0475 7.9457 2.7976l-1.2235 1.5078c-1.2531-1.0115-2.7202-1.7265-4.2908-2.0912Zm-2.4314-7.0595c4.1674 0 7.9943 1.4507 10.9995 3.8733l-1.2225 1.5069c-2.7656-2.2321-6.218-3.4475-9.777-3.4421-.8539 0-1.6922.0679-2.5092.2006l-1.6485-1.6444c1.3315-.3227 2.7251-.4943 4.1577-.4943Z" />
        </g>
        <defs>
            <clipPath id="clip0_6387_39471">
                <path fill="#fff" d="M0 0h36v48H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const DamagePowerIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 36 48" fill="#000">
        <path
            fill="currentColor"
            stroke="none"
            fillRule="evenodd"
            d="M24 0H4C1.79086 0 0 1.79086 0 4v40c0 2.2091 1.79086 4 4 4h20c2.2091 0 4-1.7909 4-4v-6h-2v6c0 1.1046-.8954 2-2 2H4c-1.10457 0-2-.8954-2-2V4c0-1.10457.89543-2 2-2h20c1.1046 0 2 .89543 2 2v7h2V4c0-2.20914-1.7909-4-4-4Z"
            clipRule="evenodd"
        />
        <circle cx="7" cy="7" r="2" fill="currentColor" stroke="none" />
        <rect width="8" height="2" x="10" y="41" fill="currentColor" stroke="none" rx="1" />
        <rect
            width="8"
            height="2"
            x="24"
            y="22"
            fill="currentColor"
            stroke="none"
            rx="1"
            transform="rotate(-90 24 22)"
        />
        <path
            fill="currentColor"
            stroke="none"
            fillRule="evenodd"
            d="M22.3419 18.5592c.2436.4956.0393 1.0949-.4564 1.3385C19.5762 21.0326 18 23.3829 18 26.0891c0 3.8064 3.1235 6.9111 7 6.9111 3.8766 0 7-3.1047 7-6.9111 0-2.7062-1.5762-5.0565-3.8855-6.1914-.4957-.2436-.7-.8429-.4564-1.3385.2436-.4957.8428-.7 1.3385-.4565C31.9557 19.557 34 22.5827 34 26.0891c0 4.932-4.04 8.9111-9 8.9111s-9-3.9791-9-8.9111c0-3.5064 2.0443-6.5321 5.0034-7.9864.4957-.2435 1.0949-.0392 1.3385.4565Z"
            clipRule="evenodd"
        />
    </svg>
)

export const DividerIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="#000">
        <path d="M12.5 4h-1v16h1V4Z" fill="#000" />
    </svg>
)

export const EditIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 16 16" fill="#000">
        <g clipPath="url(#clip0_6497_16201)">
            <path
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.3"
                fill="none"
                d="M3.20711 9.29289 1.5 14.5l5.20711-1.7071m-3.5-3.50001L11 1.5 14.5 5l-7.79289 7.7929m-3.5-3.50001 3.5 3.50001"
            />
        </g>
        <defs>
            <clipPath id="clip0_6497_16201">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const FacebookIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 96 96" fill="#000">
        <path
            d="M92 48.267c0-24.3-19.699-44-44-44s-44 19.7-44 44C4 70.23 20.09 88.433 41.125 91.733V60.987H29.953v-12.72h11.172v-9.694c0-11.026 6.569-17.117 16.619-17.117 4.815 0 9.85.858 9.85.858v10.828h-5.549c-5.465 0-7.17 3.392-7.17 6.871v8.255h12.203l-1.951 12.718H54.875v30.747C75.91 88.433 92 70.228 92 48.267"
            fill="currentColor"
        />
    </svg>
)

export const FlexIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 18 18" fill="#000">
        <path
            fill="currentColor"
            stroke="none"
            d="M9.19437 16.8111C4.95321 16.8111 1.5 13.3777 1.5 9.15709 1.5 4.93648 4.95007 1.5 9.19437 1.5c2.05623 0 3.98693.79664 5.44033 2.24308l-.4143.41238c-1.3437-1.3371-3.1268-2.07126-5.02603-2.07126-3.91782 0-7.10732 3.17406-7.10732 7.07289 0 3.89881 3.18636 7.07291 7.10732 7.07291 3.92093 0 7.10733-3.1741 7.10733-7.07291V7.90122h.587v1.25587c0 4.22061-3.45 7.65401-7.69433 7.65401Z"
        />
        <path
            fill="currentColor"
            stroke="none"
            d="M9.1944 15.4208c-3.47204 0-6.29425-2.8085-6.29425-6.26373 0-3.45522 2.82535-6.26376 6.29425-6.26376 1.6827 0 3.2617.65293 4.4515 1.83383l-.4144.41238c-1.0768-1.07156-2.5114-1.66513-4.0371-1.66513-3.1487 0-5.70721 2.54924-5.70721 5.67955 0 3.13036 2.56165 5.67956 5.70721 5.67956 3.1456 0 5.7072-2.5492 5.7072-5.67956V6.50473h.5871v2.64921c0 3.45526-2.8254 6.26376-6.2943 6.26376v.0031Z"
        />
        <path
            fill="currentColor"
            stroke="none"
            d="M9.19439 14.0275c-2.69978 0-4.89727-2.1869-4.89727-4.87356 0-2.6867 2.19749-4.87354 4.89727-4.87354 1.30911 0 2.53651.50609 3.46261 1.42769l-.4144.41238c-.813-.80913-1.8961-1.25587-3.04821-1.25587-2.37643 0-4.31023 1.92442-4.31023 4.28934 0 2.36496 1.9338 4.28936 4.31023 4.28936 2.37641 0 4.31021-1.9244 4.31021-4.28936V7.89807h.5871v1.25587c0 2.68666-2.1975 4.87356-4.89731 4.87356Z"
        />
        <path
            fill="currentColor"
            stroke="none"
            d="m17.4163 9.12893-2.2195-2.20872-2.2194 2.20872-.4144-.41238 2.6338-2.62109 2.6339 2.62109-.4144.41238Z"
        />
    </svg>
)

export const InfoIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <path
            d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM12 16v-4M12 8h.01"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const InfoSmallIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#e)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5ZM.25 8a7.75 7.75 0 1 1 15.5 0A7.75 7.75 0 0 1 .25 8Zm7.34-.21H6.9v-1.5h2.19v6.51h-1.5V7.79Zm.57-2.39a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z"
                stroke="none"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="e">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const InstagramIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 96 96" fill="#000">
        <path
            d="M41.56 5.004h12.88c6.046.022 7.725.088 11.289.25 4.577.21 7.703.936 10.438 1.999 2.827 1.099 5.225 2.57 7.616 4.96 2.39 2.39 3.86 4.789 4.96 7.616 1.019 2.625 1.73 5.611 1.97 9.896l.15 3.428c.101 2.775.133 5.555.136 13.312l-.009 8.204c-.022 5.858-.088 7.54-.25 11.056-.208 4.577-.935 7.703-1.997 10.438-1.1 2.827-2.57 5.225-4.96 7.616-2.391 2.39-4.79 3.86-7.616 4.96-2.626 1.02-5.612 1.73-9.896 1.97l-3.429.15c-2.775.102-5.555.133-13.312.137l-8.204-.01c-5.857-.022-7.538-.088-11.055-.25-4.577-.208-7.703-.934-10.438-1.997-2.827-1.1-5.225-2.57-7.616-4.96-2.39-2.391-3.861-4.79-4.96-7.616-1.02-2.626-1.73-5.612-1.97-9.896l-.12-2.62c-.119-2.915-.159-5.323-.166-12.71l.007-9.381c.021-6.047.087-7.726.25-11.29.21-4.576.937-7.702 1.999-10.437 1.099-2.827 2.57-5.225 4.96-7.616 2.39-2.39 4.789-3.861 7.616-4.96 2.625-1.02 5.611-1.73 9.895-1.97l2.621-.12c2.397-.097 4.45-.142 9.21-.159zm13.468 7.75H40.971c-5.353.023-6.969.087-10.347.24-4.192.192-6.47.892-7.984 1.48-2.007.78-3.44 1.713-4.944 3.218-1.505 1.504-2.437 2.937-3.217 4.944l-.186.496c-.522 1.452-1.079 3.56-1.274 7.062l-.138 3.177c-.09 2.447-.123 4.828-.131 10.757l.008 10.896c.022 5.353.086 6.969.24 10.347.192 4.193.892 6.47 1.48 7.985.78 2.007 1.713 3.44 3.218 4.944 1.504 1.505 2.937 2.437 4.944 3.217l.495.186c1.395.5 3.393 1.034 6.648 1.247l.84.047c4.328.197 5.764.247 15.872.25l8.475-.01c5.4-.022 7.015-.085 10.406-.24l.84-.047c3.662-.24 5.733-.885 7.144-1.433 2.007-.78 3.44-1.712 4.944-3.217 1.505-1.504 2.437-2.937 3.217-4.944l.185-.496c.522-1.453 1.079-3.56 1.274-7.062l.136-3.131c.091-2.466.125-4.84.133-10.814l-.008-10.827c-.022-5.4-.085-7.015-.24-10.405-.191-4.193-.891-6.47-1.48-7.985-.78-2.007-1.712-3.44-3.217-4.944-1.504-1.505-2.937-2.437-4.944-3.217l-.496-.186c-1.453-.522-3.56-1.078-7.062-1.273l-3.36-.145c-1.896-.068-3.806-.101-7.414-.117zM48 25.914c12.195 0 22.08 9.886 22.08 22.082 0 12.194-9.885 22.081-22.08 22.081-12.195 0-22.081-9.887-22.081-22.08 0-12.197 9.886-22.083 22.08-22.083zm0 7.748c-7.916 0-14.333 6.417-14.333 14.334 0 7.916 6.417 14.333 14.333 14.333s14.333-6.417 14.333-14.333c0-7.917-6.417-14.334-14.333-14.334zm22.953-13.78a5.16 5.16 0 1 1 0 10.32 5.16 5.16 0 0 1 0-10.32z"
            fill="currentColor"
        />
    </svg>
)

export const InvoicesIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 32 32" fill="#000">
        <path
            fill="currentColor"
            stroke="none"
            fillRule="evenodd"
            d="M5.91675 4c0-1.51878 1.23122-2.75 2.75-2.75H20.3675c.717 0 1.4056.28003 1.9191.78042l6.2993 6.13804c.5312.51762.8308 1.22788.8308 1.96954V28.5c0 1.5188-1.2312 2.75-2.75 2.75H8.66675c-1.51879 0-2.75-1.2312-2.75-2.75V4Zm2.75-1.25c-.69036 0-1.25.55964-1.25 1.25v24.5c0 .6904.55964 1.25 1.25 1.25H26.6667c.6904 0 1.25-.5596 1.25-1.25V10.2523h-4.736c-1.5187 0-2.75-1.23118-2.75-2.74996V2.7516c-.021-.00106-.0421-.0016-.0632-.0016H8.66675ZM21.9307 3.77797l5.1051 4.97437h-3.8551c-.6903 0-1.25-.55965-1.25-1.25V3.77797ZM11.1667 14.0812H23.881v-1.5H11.1667v1.5Zm12.7143 4.2381H11.1667v-1.5H23.881v1.5Zm-12.7143 4.2381H23.881v-1.5H11.1667v1.5Z"
            clipRule="evenodd"
        />
    </svg>
)

export const LinkedinIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 96 96" fill="#000">
        <path
            d="M83.001 8a4.999 4.999 0 0 1 4.994 4.782L88 13v70.002a4.999 4.999 0 0 1-4.782 4.994L83 88H12.998a4.999 4.999 0 0 1-4.993-4.782L8 83V12.999a4.999 4.999 0 0 1 4.781-4.994L12.998 8h70.003zM32.188 37.804H19.833l.15 38.5 12.205-.155V37.804zm40.639 3.05c-2.686-3.016-7.337-4.54-12.14-3.985-4.253.495-7.856 2.544-9.812 5.538l.006-1.879.025-2.724H38.994l.15 38.5 12.205-.155.001-21.494c.012-.346.106-1.882.849-3.4 1.112-2.272 3.089-3.438 5.876-3.465 1.597.006 2.91.472 3.903 1.451 1.748 1.726 2.02 4.508 2.063 5.282l.008.205.049 21.575L76.3 76.15l.015-1.654c.013-1.988.015-4.814.013-7.783l-.038-14.555c-.025-1.366-.314-7.766-3.463-11.303zM25.924 19.212a6.869 6.869 0 1 0 0 13.738 6.869 6.869 0 0 0 0-13.738z"
            fill="currentColor"
        />
    </svg>
)

export const PhoneIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#f)">
            <path
                clipRule="evenodd"
                d="M6.013 1.07s-.285-.085-.432-.06c-3.942.658-4.536 2.955-4.56 3.05a.742.742 0 0 0 .015.404C5.739 19.079 15.51 21.787 18.724 22.679c.247.067.45.123.605.175a.75.75 0 0 0 .539-.032c.098-.046 2.42-1.14 2.986-4.715a.757.757 0 0 0-.07-.457c-.052-.097-1.267-2.412-4.634-3.23a.72.72 0 0 0-.657.159c-1.063.907-2.531 1.877-3.164 1.975-4.245-2.078-6.616-6.067-6.706-6.824-.05-.426.922-1.92 2.042-3.135a.746.746 0 0 0 .193-.571C9.573 2.744 6.013 1.07 6.013 1.07Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </g>
        <defs>
            <clipPath id="f">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const PlusIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 16 16" fill="#000">
        <path
            fill="currentColor"
            stroke="none"
            d="M8.99989 1.68629H7.00011v5.31382H1.68629V8.9999h5.31382v5.3138h1.99978V8.9999h5.31381V7.00011H8.99989V1.68629Z"
        />
    </svg>
)

// Unused
export const ReturnIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} width="56" height="55" fill="none">
        <g clipPath="url(#return-icon-clip-path)">
            <mask id="return-icon-mask" maskUnits="userSpaceOnUse" x="3" y="3" width="50" height="49">
                <path d="M52.278 3.055H3.389v48.889h48.889V3.055z" fill="#fff" />
            </mask>
            <g mask="url(#return-icon-mask)">
                <path
                    d="M26.237 4.012c.477-.241 1.04-.257 1.528-.048l.104.048 22.134 11.185.047.033c.019.01.04.015.058.026.041.025.072.06.108.089l.112.092c.033.033.062.069.09.105l.041.056c.027.036.056.069.079.108.04.069.067.143.094.217l.038.097a1.33 1.33 0 0 1 .041.223l.005.115v18.931c-.708-.553-1.496-1.004-2.344-1.337l-.256-.096V18.431l-19.764 9.558v19.659l2.684-1.358v2.915l-3.397 1.72c-.017.008-.034.016-.052.022l-.107.035c-.034.012-.067.029-.101.038a1.32 1.32 0 0 1-.327.045 1.32 1.32 0 0 1-.327-.045c-.035-.009-.067-.026-.101-.038l-.107-.036-.052-.022L4.38 39.744c-.579-.292-.951-.863-.988-1.505l-.003-.108V16.358c0-.116.017-.229.046-.338.009-.034.027-.063.038-.096.027-.075.055-.149.094-.218l.038-.055.041-.053a1.29 1.29 0 0 1 .132-.161c.034-.034.073-.062.112-.092l.071-.061c.012-.01.024-.019.038-.028l.058-.026.046-.033L26.237 4.012zm10.33 27.896l1.474 1.468-2.512 2.522h9.43c1.139 0 2.212.286 3.156.786a6.85 6.85 0 0 1 2.445 2.181 6.8 6.8 0 0 1 1.195 3.857c0 3.645-2.887 6.732-6.338 6.821l-.153.002H33.637v-2.601h11.629c2.072 0 3.89-1.973 3.89-4.223 0-.863-.26-1.665-.703-2.335a4.21 4.21 0 0 0-2.35-1.725 4.19 4.19 0 0 0-.946-.159l-.197-.005-9.426-.001 2.508 2.529-1.477 1.466-5.259-5.301 5.26-5.283zM5.989 18.431v19.212l19.764 10.005V27.989L5.989 18.431zm9.894-6.273l-8.261 4.174 19.431 9.398 8.446-4.085-19.616-9.487zm11.17-5.644l-8.249 4.169L38.486 20.2l7.997-3.868-19.43-9.818z"
                    fill="#fff"
                />
            </g>
        </g>
        <defs>
            <clipPath id="return-icon-clip-path">
                <path fill="#fff" transform="translate(3.389 3.055)" d="M0 0h48.889v48.889H0z" />
            </clipPath>
        </defs>
    </svg>
)

export const SubscriptionsIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 32 32" fill="#000">
        <path
            fill="currentColor"
            stroke="none"
            fillRule="evenodd"
            d="M15.5 4.75c-1.5188 0-2.75 1.23122-2.75 2.75V29c0 1.5188 1.2312 2.75 2.75 2.75h11c1.5188 0 2.75-1.2312 2.75-2.75V7.5c0-1.51878-1.2312-2.75-2.75-2.75h-11ZM14.25 7.5c0-.69036.5596-1.25 1.25-1.25h11c.6904 0 1.25.55964 1.25 1.25V29c0 .6904-.5596 1.25-1.25 1.25h-11c-.6904 0-1.25-.5596-1.25-1.25V7.5Zm6.875 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            stroke="none"
            fillRule="evenodd"
            d="M6.5.25C4.98122.25 3.75 1.48122 3.75 3v21.5c0 1.5188 1.23122 2.75 2.75 2.75h7.0984v-1.5H6.5c-.69036 0-1.25-.5596-1.25-1.25V3c0-.69036.55964-1.25 1.25-1.25h11c.6904 0 1.25.55964 1.25 1.25v3h1.5V3c0-1.51878-1.2312-2.75-2.75-2.75h-11Zm5.125 2.25c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1Z"
            clipRule="evenodd"
        />
    </svg>
)

export const TwitterIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 96 96" fill="#000">
        <path
            d="M31.304 84.563c33.964 0 52.537-28.13 52.537-52.524 0-.8-.016-1.595-.053-2.387A37.575 37.575 0 0 0 93 20.095 36.871 36.871 0 0 1 82.396 23a18.523 18.523 0 0 0 8.119-10.21 37.053 37.053 0 0 1-11.724 4.48 18.452 18.452 0 0 0-13.479-5.832c-10.198 0-18.467 8.268-18.467 18.459 0 1.449.162 2.857.479 4.209-15.346-.773-28.954-8.119-38.06-19.288a18.382 18.382 0 0 0-2.501 9.278c0 6.405 3.26 12.058 8.217 15.366a18.327 18.327 0 0 1-8.363-2.309c-.004.078-.004.154-.004.236 0 8.941 6.365 16.404 14.814 18.097a18.518 18.518 0 0 1-4.868.65 18.36 18.36 0 0 1-3.471-.334c2.351 7.334 9.167 12.673 17.25 12.822a37.061 37.061 0 0 1-22.934 7.903c-1.49 0-2.959-.085-4.404-.257a52.281 52.281 0 0 0 28.304 8.293"
            fill="currentColor"
        />
    </svg>
)

export const WalletIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <path
            stroke="none"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7207 7.77011H19.3563C19.7113 7.77011 20 8.05885 20 8.41379V12.1839V15.5862V19.3563C20 19.7113 19.7113 20 19.3563 20H6.21333C4.99292 20 4 18.8305 4 17.3929V6.34483C4 5.05195 5.01628 4 6.26556 4H18.0771C18.432 4 18.7207 4.28874 18.7207 4.64368V7.77011ZM6.26546 4.91992H17.8011V7.7705H6.26546C5.5232 7.7705 4.91943 7.13105 4.91943 6.34521C4.91943 5.55937 5.5232 4.91992 6.26546 4.91992ZM4.91953 17.3931C4.91953 18.3237 5.49995 19.0806 6.21332 19.0806H19.0805V16.2301H15.7701C14.477 16.2301 13.4253 15.1781 13.4253 13.8852C13.4253 12.5924 14.477 11.5404 15.7701 11.5404H19.0805V8.68983H18.077H6.26555C5.76128 8.68983 5.29636 8.5164 4.91953 8.22656V17.3931ZM15.7702 15.3107H19.0806V12.4602H15.7702C14.9844 12.4602 14.3449 13.0996 14.3449 13.8854C14.3449 14.6713 14.9844 15.3107 15.7702 15.3107Z"
            fill="currentColor"
        />
    </svg>
)

export const WarningCircleIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 30 30" fill="none">
        <path
            fill="currentColor"
            stroke="none"
            d="M15 3.31731C8.54712 3.31731 3.31731 8.54712 3.31731 15c0 6.4529 5.22981 11.6827 11.68269 11.6827 6.4529 0 11.6827-5.2298 11.6827-11.6827 0-6.45288-5.2298-11.68269-11.6827-11.68269ZM15 1.875c7.249 0 13.125 5.87596 13.125 13.125 0 7.249-5.876 13.125-13.125 13.125-7.24904 0-13.125-5.876-13.125-13.125C1.875 7.75096 7.75096 1.875 15 1.875Z"
        />
        <path
            fill="currentColor"
            stroke="none"
            d="M15.7031 6.5625v9.375h-1.4062v-9.375h1.4062Zm.2344 13.125c0-.5188-.4187-.9375-.9375-.9375-.5187 0-.9375.4187-.9375.9375 0 .5187.4188.9375.9375.9375.5188 0 .9375-.4188.9375-.9375Z"
        />
    </svg>
)

export const WarningIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 24 24" fill="none">
        <mask id="g" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <path fill="currentColor" d="M0 0h24v24H0z" />
        </mask>
        <g mask="url(#g)" stroke="none">
            <path
                d="M1 21 12 2l11 19H1Zm3.45-2h15.1L12 6 4.45 19ZM12 18a.968.968 0 0 0 .713-.288A.967.967 0 0 0 13 17a.967.967 0 0 0-.287-.712A.968.968 0 0 0 12 16a.965.965 0 0 0-.712.288A.965.965 0 0 0 11 17c0 .283.096.52.288.712A.965.965 0 0 0 12 18Zm-1-3h2v-5h-2v5Z"
                fill="currentColor"
            />
        </g>
    </svg>
)

export const YoutubeIcon = (props: IconProps) => (
    <svg className={classNames('icon', props.className)} viewBox="0 0 96 96" fill="#000">
        <path
            d="M46.415 15.003h3.174c6.211.033 28.834.27 35.138 1.965a11.79 11.79 0 0 1 8.31 8.336c1.662 6.217 1.918 18.146 1.958 21.682l.003 1.712c-.028 3.084-.247 15.579-1.96 21.994a11.793 11.793 0 0 1-8.311 8.336c-6.89 1.851-33.277 1.962-36.419 1.97l-3.137-.014c-7.542-.058-27.956-.36-33.894-1.956a11.794 11.794 0 0 1-8.311-8.336c-1.849-6.921-1.957-20.917-1.964-22.54l.01-1.364c.046-3.763.323-15.378 1.954-21.484a11.793 11.793 0 0 1 8.31-8.336c6.305-1.695 28.928-1.932 35.139-1.965zm-8.262 18.66V62.33l25.28-14.332-25.28-14.334z"
            fill="currentColor"
        />
    </svg>
)
